import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { gameActions } from './action/GameAction';
import { history } from './helpers/history';
import { commonClass } from './helpers/commonClass';

class BonusDetailspopup extends Component {
    constructor(props) {
        super(props);
        this.state = {

        }
        if (!this.props.Availbonus || this.props.Availbonus.length <= 0) {
            // 1 - register,2 - wallet
            this.props.ShowAvailableBonus(this.props.user.mobileNo, this.props.i18n.language, this.props.user.loginKey, this.props.filtertype);
        }
    }


    static getDerivedStateFromProps(props, state) {
        return { Availbonus: props.Availbonus };
    };

    Moreinfo = () => {
        history.push('/bonus-details')
    }

    ApplyBonus = (Obj) => {
        this.props.getbonus(Obj);
        setTimeout(() => {
            this.props.ClosePopup()
        }, 500);
    }

    render() {
        const { t } = this.props;
        return (
            <>
                {this.props.Availbonus && this.props.Availbonus.length > 0 &&
                    <div className="row">
                        <div className="col" style={{ height: "30px" }}><b>{t('lblavailbonus')}</b></div>
                        <div className="col" style={{ height: "30px" }} ></div>
                        <div className="col" style={{ height: "30px" }} ></div>
                    </div>
                }
                {
                    this.props.Availbonus && this.props.Availbonus.length > 0 && this.props.Availbonus.map((x1, inx1) =>
                        <div className="row">
                            <div className="col" style={{ height: "60px" }}>{x1.bonus_name}</div>
                            <div className="col" style={{ height: "60px", textDecoration: "underline" }}> <a href={`${commonClass.setUrl()}/bonus-details-separate?bonus_id=${x1.bonus_id}`} target="_blank" rel="noopener" >{t('lblmoredetails')}</a></div>
                            <div className="col" style={{ height: "60px" }} onClick={() => { this.ApplyBonus(x1) }}><button className='styled-button'>{t('lblapply')}</button></div>
                        </div>
                    )
                }

                {this.props.Availbonus.length == 0 &&
                    <h1>{t('lblNotAvl')}</h1>
                }

            </>
        );
    }
}

function mapStateToProps(state) {
    const { user, appvariables } = state.loginReducer;
    const { Availbonus } = state.gameReducer;
    return { user, appvariables, Availbonus };
}
const mapActionToProps = {
    ShowAvailableBonus: gameActions.ShowAvailableBonus
}
export default connect(mapStateToProps, mapActionToProps)(withTranslation()(BonusDetailspopup))